module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Node.js"));
	}, "Node");
}